import { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import BaseLayout from '../../commons/BaseLayout';
import { getOrCreateSessionId, loadProgressRecordWithStatus } from '../../pages/SpinWheel/spinWheelProgressService';
import HomePageAdult from './HomePageAdult';
import HomePageChild from './HomePageChild';
import './home.css';

const VERSION_STORAGE_KEY = '@kitoApp/version';

export default function HomePage() {
  const [activeVersion, setActiveVersion] = useState(
    () => globalThis.localStorage.getItem(VERSION_STORAGE_KEY) || 'Adult'
  );
  const [isSpinWheelModalOpen, setIsSpinWheelModalOpen] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const audioRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    const checkSpinWheelProgress = async () => {
      try {
        const sessionId = getOrCreateSessionId();
        const { becameEligible } = await loadProgressRecordWithStatus(sessionId);

        if (isMounted && becameEligible) {
          setIsSpinWheelModalOpen(true);
        }
      } catch (error) {
        // The home page remains usable if spin progress cannot be loaded.
        // eslint-disable-next-line no-console
        console.error('Error checking spin wheel progress:', error);
      }
    };

    checkSpinWheelProgress();

    return () => {
      isMounted = false;
    };


  }, []);

  const handlePlayNow = () => {
    setIsSpinWheelModalOpen(false);
    navigate('/spin-wheel');
  };

  return (
    <BaseLayout header headerLogo onVersionChange={setActiveVersion} sidebar audio={t("audioMessages.welcome")} audioName="Welcome">
      {activeVersion === 'Child' ? <HomePageChild /> : <HomePageAdult />}
      {isSpinWheelModalOpen && (
        <div className="spin-wheel-ready__overlay" onClick={() => setIsSpinWheelModalOpen(false)}>
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="spin-wheel-ready-title"
            aria-describedby="spin-wheel-ready-description"
            className="spin-wheel-ready__modal"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="spin-wheel-ready__visit-badge" aria-hidden="true">
              7
            </div>
            <h2 id="spin-wheel-ready-title">{t('staticPages.spinWheelReady.title')}</h2>
            <p id="spin-wheel-ready-description">{t('staticPages.spinWheelReady.description')}</p>
            <div className="spin-wheel-ready__actions">
              <button
                type="button"
                className="spin-wheel-ready__button spin-wheel-ready__button--later"
                onClick={() => setIsSpinWheelModalOpen(false)}
              >
                {t('staticPages.spinWheelReady.later')}
              </button>
              <button
                type="button"
                className="spin-wheel-ready__button spin-wheel-ready__button--play"
                onClick={handlePlayNow}
              >
                {t('staticPages.spinWheelReady.playNow')}
              </button>
            </div>
          </div>
        </div>
      )}
    </BaseLayout>
  );
}
